import { useEffect, useMemo, useState } from "react";
import { useMediaQuery } from "react-responsive";
import "bulma/css/bulma.css";
import { Link } from "react-router-dom";
import "../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { APISD } from "../../../../../config/apisd";
import { APIMS } from "../../../../../config/apims";
import {
  faArrowLeft,
  faBookOpen,
  faBook,
  faChalkboardTeacher,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";


export default function MataPelajaran() {
  document.title = "Buku Nilai ";

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const [isFetching, setIsFetching] = useState(true);
  const [isFetchingBookScore, setIsFetchingBookScore] = useState(false);

  const [selectedMatpel, setSelectedMatpel] = useState(null);
  const [selectedCp, setSelectedCp] = useState(null);
  const [selectedUlangan, setSelectedUlangan] = useState(null);
  const [activeMatpelTab, setActiveMatpelTab] = useState("silabus");

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [getData, setGetData] = useState([]);
  const [semesterOptions, setSemesterOptions] = useState([]);
  const [selectedSemesterId, setSelectedSemesterId] = useState("");
  const [selectedAcademicYearId, setSelectedAcademicYearId] = useState("");
  const [selectedKelasId, setSelectedKelasId] = useState("");

  const [bookScoreData, setBookScoreData] = useState({
    exams: [],
    header: [],
    data_murid: [],
  });

  const [bookScoreEmptyMessage, setBookScoreEmptyMessage] = useState(
    "Data nilai siswa belum tersedia"
  );

  const getToken = () => {
    return localStorage.getItem("token") || "";
  };

  const getUserId = () => {
    return (
      localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "") ||
      localStorage.getItem("user_id")?.replace(/[|&;$%@"<>()+,]/g, "") ||
      ""
    );
  };

  const getLoginUser = () => {
    const keys = ["user", "user_data", "data_user", "auth_user"];

    for (const key of keys) {
      try {
        const raw = localStorage.getItem(key);
        if (raw) return JSON.parse(raw);
      } catch (error) {
        // skip jika data localStorage bukan JSON valid
      }
    }

    return {};
  };

  const getTeacherId = () => {
    const user = getLoginUser();

    return (
      localStorage.getItem("teacherID") ||
      localStorage.getItem("id_teacher") ||
      localStorage.getItem("ysb_teacher_id") ||
      user?.teacherID ||
      user?.id_teacher ||
      user?.ysb_teacher_id ||
      user?.teacher_id ||
      user?.teacher?.id ||
      user?.teacher_data?.id ||
      user?.data?.teacherID ||
      user?.data?.id_teacher ||
      user?.data?.ysb_teacher_id ||
      user?.data?.teacher?.id ||
      ""
    );
  };

  const getBranchId = () => {
    const user = getLoginUser();
    return localStorage.getItem("ysb_branch_id") || user?.ysb_branch_id || "";
  };

  const getSchoolId = () => {
    const user = getLoginUser();
    return localStorage.getItem("ysb_school_id") || user?.ysb_school_id || "";
  };

  const getSemesterArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData)) return responseData;
    return [];
  };

  const getMatpelArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data_matpel)) {
      return responseData.data.data_matpel;
    }

    if (Array.isArray(responseData?.data?.data?.data_matpel)) {
      return responseData.data.data.data_matpel;
    }

    if (Array.isArray(responseData?.data?.ysb_matpel)) {
      return responseData.data.ysb_matpel;
    }

    if (Array.isArray(responseData?.data?.data?.ysb_matpel)) {
      return responseData.data.data.ysb_matpel;
    }

    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData)) return responseData;

    return [];
  };

  const getSemesterLabel = (item) => {
    return `${item?.name_year || "-"} (Semester ${item?.semester || "-"})`;
  };

  const formatNilai = (value) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }

    const numberValue = Number(value);

    if (Number.isNaN(numberValue)) {
      return value;
    }

    if (Number.isInteger(numberValue)) {
      return numberValue;
    }

    return Number(numberValue.toFixed(2));
  };

  const getSumatifTpColumns = (header = [], exams = []) => {
    const sumatifHeader = (header || []).find(
      (item) => (item?.title || "").trim().toLowerCase() === "sumatif harian"
    );

    const tpList = Array.isArray(sumatifHeader?.ysb_matpel_tp)
      ? sumatifHeader.ysb_matpel_tp
      : [];

    if (tpList.length > 0) {
      return tpList.map((tp, index) => ({
        id: tp?.id || tp?.ysb_matpel_tp_id || `tp-${index}`,
        ysb_matpel_tp_id: tp?.id || tp?.ysb_matpel_tp_id || `tp-${index}`,
        name_tp: tp?.name_tp || tp?.nama_tp || tp?.name || `TP ${index + 1}`,
      }));
    }

    const dailyExams = (exams || []).filter(
      (exam) => !exam?.is_asts && !exam?.is_asas
    );

    return dailyExams.flatMap((exam, examIndex) => {
      const examTps = Array.isArray(exam?.tps) ? exam.tps : [];

      if (examTps.length > 0) {
        return examTps.map((tp, tpIndex) => ({
          id:
            tp?.id ||
            tp?.ysb_matpel_tp_id ||
            `${exam?.exam_id || examIndex}-tp-${tpIndex}`,
          ysb_matpel_tp_id:
            tp?.id ||
            tp?.ysb_matpel_tp_id ||
            `${exam?.exam_id || examIndex}-tp-${tpIndex}`,
          exam_id: exam?.exam_id || "",
          name_tp:
            tp?.name_tp ||
            tp?.nama_tp ||
            tp?.name ||
            exam?.exam_name ||
            `TP ${tpIndex + 1}`,
        }));
      }

      return [
        {
          id: exam?.exam_id || `exam-${examIndex}`,
          exam_id: exam?.exam_id || "",
          name_tp: exam?.exam_name || `Sumatif ${examIndex + 1}`,
        },
      ];
    });
  };

  const getScoreByTp = (student, tp) => {
    const dataNilai = Array.isArray(student?.data_nilai)
      ? student.data_nilai
      : [];

    const nilai = dataNilai.find((item) => {
      const itemTpId = item?.ysb_matpel_tp_id || "";
      const tpId = tp?.id || tp?.ysb_matpel_tp_id || "";
      const itemExamId = item?.exam_id || "";
      const tpExamId = tp?.exam_id || "";

      return (
        (itemTpId && tpId && String(itemTpId) === String(tpId)) ||
        (itemExamId && tpExamId && String(itemExamId) === String(tpExamId)) ||
        (item?.name_tp && tp?.name_tp && item.name_tp === tp.name_tp)
      );
    });

    return nilai?.score;
  };

  const getSemesterData = async () => {
    setIsFetching(true);

    try {
      const response = await APIMS.get("/api/access/semesters", {
        headers: {
          Authorization: getToken(),
          "Content-Type": "application/json",
        },
        params: {
          page: 1,
          limit: 100,
          ascending: 0,
          search: "",
        },
      });

      const rows = getSemesterArrayFromResponse(response?.data);
      setSemesterOptions(rows);

      const activeSemester =
        rows.find((item) => Number(item?.status) === 1) || rows[0];

      if (activeSemester) {
        setSelectedSemesterId(activeSemester?.id || "");
        setSelectedAcademicYearId(activeSemester?.ysb_academic_year_id || "");
      } else {
        setIsFetching(false);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data semester",
      });
      setIsFetching(false);
    }
  };

  const getBookExamScores = async ({ kelasId }) => {
    if (!selectedMatpel || !kelasId) {
      setBookScoreData({
        exams: [],
        header: [],
        data_murid: [],
      });
      setBookScoreEmptyMessage("Data nilai siswa belum tersedia");
      return;
    }

    setIsFetchingBookScore(true);

    try {
      const selectedKelas = (selectedMatpel?.kelas_list || []).find(
        (item) => String(item?.ysb_kelas_id || "") === String(kelasId || "")
      );

      const response = await APISD.get("/api/book-exam-scores", {
        headers: {
          Authorization: getToken(),
          "Content-Type": "application/json",
        },
        // params: {
        //   ysb_kelas_id: kelasId,
        //   ysb_matpel_id:
        //   ysb_branch_id:
        //     selectedKelas?.ysb_branch_id ||
        //     selectedMatpel?.ysb_branch_id ||
        //     getBranchId(),
        //   ysb_school_id:
        //     selectedKelas?.ysb_school_id ||
        //     selectedMatpel?.ysb_school_id ||
        //     getSchoolId(),
        // },
        params: {
          ysb_kelas_id: kelasId,
          ysb_matpel_id:
            selectedMatpel?.ysb_matpel_id ||
            selectedMatpel?.id ||
            "",
          ysb_branch_id:
            selectedKelas?.ysb_branch_id ||
            selectedMatpel?.ysb_branch_id ||
            getBranchId(),
          ysb_school_id:
            selectedKelas?.ysb_school_id ||
            selectedMatpel?.ysb_school_id ||
            getSchoolId(),
        },
      });

      const payload = response?.data?.data || {};

      setBookScoreData({
        exams: Array.isArray(payload?.exams) ? payload.exams : [],
        header: Array.isArray(payload?.header) ? payload.header : [],
        data_murid: Array.isArray(payload?.data_murid)
          ? payload.data_murid
          : [],
      });

      setBookScoreEmptyMessage("Data nilai siswa belum tersedia");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        "";

      setBookScoreData({
        exams: [],
        header: [],
        data_murid: [],
      });

      if (errorMessage === "Exam tidak ditemukan") {
        setBookScoreEmptyMessage("Ulangan belum dibuat");
        return;
      }

      setBookScoreEmptyMessage("Data nilai siswa belum tersedia");

      ToastError.fire({
        icon: "error",
        title: errorMessage || "Gagal mengambil data buku nilai",
      });
    } finally {
      setIsFetchingBookScore(false);
    }
  };

  const getMatpelTeacherData = async ({ semesterId, academicYearId }) => {
    if (!semesterId || !academicYearId) {
      setGetData([]);
      setIsFetching(false);
      return;
    }

    setIsFetching(true);

    try {
      const teacherId = getTeacherId();

      if (!teacherId) {
        ToastError.fire({
          icon: "error",
          title: "ID teacher tidak ditemukan. Silakan login ulang.",
        });

        setGetData([]);
        setIsFetching(false);
        return;
      }

      const response = await APISD.request({
        method: "GET",
        url: "/api/matpel-assignments",
        headers: {
          Authorization: getToken(),
          "Content-Type": "application/json",
        },
        params: {
          ysb_academic_year_id: academicYearId,
          ysb_semester_id: semesterId,
          ysb_branch_id: getBranchId(),
          ysb_school_id: getSchoolId(),
          ysb_teacher_id: teacherId,
        },
      });

      const rows = getMatpelArrayFromResponse(response?.data);

      const normalizedRows = rows.flatMap((item, index) => {
        const rawKelasList = Array.isArray(item?.kelas_list)
          ? item.kelas_list
          : [];

        const rawAssignments = Array.isArray(item?.assignments)
          ? item.assignments
          : [];

        const matpelId = item?.ysb_matpel_id || item?.id || `matpel-${index}`;

        const namaMatpel =
          item?.name_matpel ||
          item?.nama_matpel ||
          item?.matpel_name ||
          "-";

        const kelasList = rawKelasList.map((kelas) => {
          const assignment = rawAssignments.find(
            (assign) => assign?.assignment_id === kelas?.assignment_id
          );

          return {
            assignment_id: kelas?.assignment_id || assignment?.assignment_id || "",
            ysb_kelas_id: kelas?.ysb_kelas_id || assignment?.ysb_kelas_id || "",
            ysb_grade_level_id:
              kelas?.ysb_grade_level_id || assignment?.ysb_grade_level_id || "",
            ysb_branch_id:
              kelas?.ysb_branch_id ||
              assignment?.ysb_branch_id ||
              item?.ysb_branch_id ||
              "",
            ysb_school_id:
              kelas?.ysb_school_id ||
              assignment?.ysb_school_id ||
              item?.ysb_school_id ||
              "",
            name_level:
              kelas?.name_level ||
              kelas?.["name level"] ||
              assignment?.name_level ||
              assignment?.["name level"] ||
              "",
            nama_kelas:
              kelas?.nama_kelas ||
              kelas?.name_kelas ||
              assignment?.name_kelas ||
              assignment?.nama_kelas ||
              "-",
            state_form: assignment?.state_form ?? kelas?.state_form ?? 1,
            raw: {
              kelas,
              assignment,
            },
          };
        });

        const groupByLevel = kelasList.reduce((acc, kelas) => {
          const levelKey = kelas?.name_level || "tanpa_level";
          if (!acc[levelKey]) acc[levelKey] = [];
          acc[levelKey].push(kelas);
          return acc;
        }, {});

        return Object.entries(groupByLevel).map(([level, kelasByLevel]) => {
          const gradeLevelIds = [
            ...new Set(
              kelasByLevel
                .map((kelas) => kelas?.ysb_grade_level_id)
                .filter(Boolean)
            ),
          ];

          const kelasIds = [
            ...new Set(
              kelasByLevel.map((kelas) => kelas?.ysb_kelas_id).filter(Boolean)
            ),
          ];

          const gradeLevelId = gradeLevelIds?.[0] || "";

          return {
            row_key: `${matpelId}-grade-${gradeLevelId || level}`,
            id: matpelId,
            ysb_matpel_id: matpelId,
            ysb_grade_level_id: gradeLevelId,
            selected_grade_level_ids: gradeLevelIds,
            selected_kelas_ids: kelasIds,
            nama_matpel: namaMatpel,
            name_level: level,
            nama_tingkatan:
              level !== "tanpa_level" ? `Kelas ${level}` : "Tanpa Tingkatan",
            kelas_list: kelasByLevel,
            assignments: kelasByLevel,
            total_kelas: kelasByLevel.length,
            raw: item,
          };
        });
      });

      setGetData(normalizedRows);
    } catch (error) {
      setGetData([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message || "Gagal mengambil data buku nilai",
      });
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    getSemesterData();
  }, []);

  useEffect(() => {
    if (selectedSemesterId && selectedAcademicYearId) {
      getMatpelTeacherData({
        semesterId: selectedSemesterId,
        academicYearId: selectedAcademicYearId,
      });
    }
  }, [selectedSemesterId, selectedAcademicYearId]);

  useEffect(() => {
    if (!selectedMatpel) {
      setSelectedKelasId("");
      setBookScoreData({
        exams: [],
        header: [],
        data_murid: [],
      });
      return;
    }

    const firstKelasId =
      selectedMatpel?.ysb_kelas_id ||
      selectedMatpel?.selected_kelas_ids?.[0] ||
      selectedMatpel?.kelas_list?.[0]?.ysb_kelas_id ||
      "";

    setSelectedKelasId(firstKelasId);
  }, [selectedMatpel]);

  useEffect(() => {
    if (
      selectedMatpel &&
      selectedKelasId &&
      selectedAcademicYearId &&
      selectedSemesterId
    ) {
      getBookExamScores({
        kelasId: selectedKelasId,
      });
    }
  }, [
    selectedMatpel,
    selectedKelasId,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );

  const sortedBookStudents = useMemo(() => {
    const students = Array.isArray(bookScoreData?.data_murid)
      ? bookScoreData.data_murid
      : [];

    return students
      .map((student, originalIndex) => ({ student, originalIndex }))
      .sort((a, b) => {
        const nameA = a.student?.nama_lengkap || a.student?.nama || "";
        const nameB = b.student?.nama_lengkap || b.student?.nama || "";
        const nameComparison = nameCollator.compare(nameA, nameB);

        return nameComparison !== 0
          ? nameComparison
          : a.originalIndex - b.originalIndex;
      })
      .map(({ student }) => student);
  }, [bookScoreData?.data_murid, nameCollator]);

  const filteredData = useMemo(() => {
    const q = (searchKeyword || "").trim().toLowerCase();

    const base = !q
      ? getData || []
      : (getData || []).filter((item) => {
          const namaMatpel = (item?.nama_matpel || "")
            .toString()
            .toLowerCase();

          const namaTingkatan = (item?.nama_tingkatan || "")
            .toString()
            .toLowerCase();

          return namaMatpel.includes(q) || namaTingkatan.includes(q);
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.nama_matpel || "").toString().trim(),
        (b?.nama_matpel || "").toString().trim()
      )
    );
  }, [getData, searchKeyword, nameCollator]);

  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));
    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
    if (tablePage < 1) setTablePage(1);
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);
    if (left > 2) pages.push("...");

    for (let i = left; i <= right; i++) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }

    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages.filter((v, idx, arr) => arr.indexOf(v) === idx);
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const p = Math.min(Math.max(1, Number(nextPage) || 1), totalPages);
    setTablePage(p);
  };

  const handleClickMatpel = (row) => {
    const selectedKelasIds = Array.isArray(row?.selected_kelas_ids)
      ? row.selected_kelas_ids
      : (row?.kelas_list || [])
          .map((kelas) => kelas?.ysb_kelas_id)
          .filter(Boolean);

    const selectedGradeLevelIds = Array.isArray(row?.selected_grade_level_ids)
      ? row.selected_grade_level_ids
      : [row?.ysb_grade_level_id].filter(Boolean);

    setSelectedMatpel({
      ...row,
      id: row?.ysb_matpel_id || row?.id || "",
      ysb_matpel_id: row?.ysb_matpel_id || row?.id || "",
      ysb_grade_level_id:
        row?.ysb_grade_level_id || selectedGradeLevelIds?.[0] || "",
      selected_grade_level_ids: selectedGradeLevelIds,
      selected_kelas_ids: selectedKelasIds,
      ysb_kelas_id: selectedKelasIds?.[0] || "",
    });

    setSelectedCp(null);
    setSelectedUlangan(null);
    setActiveMatpelTab("silabus");
  };

  const handleBackToMatpel = () => {
    setSelectedMatpel(null);
    setSelectedCp(null);
    setSelectedUlangan(null);
    setActiveMatpelTab("silabus");
  };

  const handleBackToUlanganTab = () => {
    setSelectedUlangan(null);
    setActiveMatpelTab("ulangan");
  };

  const handleChangeSemester = (e) => {
    const semesterId = e.target.value;
    const semester = semesterOptions.find(
      (item) => String(item?.id || "") === String(semesterId || "")
    );

    setSelectedSemesterId(semesterId);
    setSelectedAcademicYearId(semester?.ysb_academic_year_id || "");
    setSelectedMatpel(null);
    setSelectedCp(null);
    setSelectedUlangan(null);
    setSearchKeyword("");
    setTablePage(1);
  };

  // if (selectedMatpel && selectedCp) {
  //   return (
  //     <TpPage
  //       selectedMatpel={selectedMatpel}
  //       selectedCp={selectedCp}
  //       setSelectedCp={setSelectedCp}
  //       getToken={getToken}
  //       getUserId={getUserId}
  //       nameCollator={nameCollator}
  //       ToastSuccess={ToastSuccess}
  //       ToastError={ToastError}
  //     />
  //   );
  // }

  // if (selectedMatpel && selectedUlangan) {
  //   return (
  //     <DetailUlanganPage
  //       selectedMatpel={selectedMatpel}
  //       selectedUlangan={selectedUlangan}
  //       setSelectedUlangan={handleBackToUlanganTab}
  //       selectedAcademicYearId={selectedAcademicYearId}
  //       selectedSemesterId={selectedSemesterId}
  //       getToken={getToken}
  //       getUserId={getUserId}
  //       getBranchId={getBranchId}
  //       getSchoolId={getSchoolId}
  //       nameCollator={nameCollator}
  //       ToastSuccess={ToastSuccess}
  //       ToastError={ToastError}
  //     />
  //   );
  // }

  if (selectedMatpel) {
    const sumatifTpColumns = getSumatifTpColumns(
      bookScoreData?.header,
      bookScoreData?.exams
    );

    return (
      <div className="body">
        <style>{`
          .book-score-table-wrap {
            width: 100%;
            max-height: calc(100vh - 250px);
            overflow: auto;
            border: 1px solid #dbe4ee;
            border-radius: 10px;
            background: #ffffff;
            scrollbar-color: #cbd5e1 transparent;
            scrollbar-width: thin;
            -webkit-overflow-scrolling: touch;
          }

          .book-score-table-wrap::-webkit-scrollbar {
            width: 9px;
            height: 9px;
          }

          .book-score-table-wrap::-webkit-scrollbar-track {
            background: transparent;
          }

          .book-score-table-wrap::-webkit-scrollbar-thumb {
            border-radius: 999px;
            background: #cbd5e1;
          }

          .book-score-table {
            width: 100% !important;
            min-width: 100%;
            table-layout: auto;
            margin-bottom: 0 !important;
            border-collapse: separate !important;
            border-spacing: 0 !important;
            color: #334155;
            font-size: 13px;
          }

          .book-score-table th,
          .book-score-table td {
            height: 58px;
            padding: 12px 14px !important;
            border: 0 !important;
            border-right: 1px solid #e2e8f0 !important;
            border-bottom: 1px solid #e2e8f0 !important;
            text-align: center;
            vertical-align: middle !important;
            white-space: nowrap;
          }

          .book-score-table thead th {
            position: sticky;
            top: 0;
            z-index: 6;
            height: 58px;
            background: #f2f3fc !important;
            color: #172554 !important;
            font-weight: 700;
            white-space: normal;
          }

          .book-score-table thead tr:nth-child(2) th {
            top: 58px;
            z-index: 7;
          }

          .book-score-table tbody tr:nth-child(odd) td {
            background: #ffffff !important;
          }

          .book-score-table tbody tr:nth-child(even) td {
            background: #f8fafc !important;
          }

          .book-score-table tbody tr:hover td {
            background: #f1f5ff !important;
          }

          .book-score-table thead tr:first-child th:first-child,
          .book-score-table td:first-child {
            position: sticky;
            left: 0;
            z-index: 3;
            width: 68px !important;
            min-width: 68px !important;
            max-width: 68px !important;
            padding-right: 8px !important;
            padding-left: 8px !important;
          }

          .book-score-table thead tr:first-child th:first-child {
            z-index: 10;
            background: #f2f3fc !important;
          }

          .book-score-table thead tr:first-child th:nth-child(2),
          .book-score-table td:nth-child(2) {
            position: sticky;
            left: 68px;
            z-index: 3;
            width: 300px;
            min-width: 300px !important;
            max-width: 300px;
            text-align: left;
            white-space: normal;
            box-shadow: 5px 0 10px -10px rgba(0, 76, 255, 0.55);
          }

          .book-score-table thead tr:first-child th:nth-child(2) {
            z-index: 10;
            background: #f2f3fc !important;
          }

          .book-score-table tbody td:nth-child(2) {
            color: #1f2937 !important;
            font-weight: 600 !important;
          }

          .book-score-number {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border: 1px solid #d4ddff;
            border-radius: 50%;
            background: #f5f7ff;
            color: #3f5bea;
            font-weight: 700;
          }

          @media (max-width: 780px) {
            .book-score-table-wrap {
              max-height: calc(100vh - 210px);
            }

            .book-score-table thead tr:first-child th:nth-child(2),
            .book-score-table td:nth-child(2) {
              width: 220px;
              min-width: 220px !important;
              max-width: 220px;
            }
          }
        `}</style>
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faBook} />
              </span>

              <div>
                <h4 className="page-title-text mb-0">
                  {selectedMatpel?.nama_matpel || "Buku Nilai"} - Kelas{" "}
                  {selectedMatpel?.name_level || "-"}
                </h4>
              </div>
            </div>

            <div className="ml-auto">
              <button
                type="button"
                className="btn btn-light"
                onClick={handleBackToMatpel}
                style={{
                  borderRadius: 12,
                  padding: "8px 14px",
                  fontWeight: 600,
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} /> Kembali
              </button>
            </div>
          </div>

          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link onClick={handleBackToMatpel}>Buku Nilai</Link>
              </li>

              <li className="custom-breadcrumb-separator">/</li>

              <li className="custom-breadcrumb-item active" aria-current="page">
                {selectedMatpel?.nama_matpel || "Buku Nilai"} - Kelas{" "}
                {selectedMatpel?.name_level || "-"}
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content">
          <div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isTabletOrMobile
                  ? "1fr"
                  : "minmax(260px, 320px)",
                gap: 16,
                alignItems: "end",
                marginBottom: 16,
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 6,
                    color: "#003c90",
                    fontSize: 13,
                    fontWeight: 600,
                    textTransform: "uppercase",
                  }}
                >
                  Kelas :
                </label>

                <select
                  className="form-control"
                  value={selectedKelasId}
                  onChange={(e) => setSelectedKelasId(e.target.value)}
                  style={{
                    height: 43,
                    borderRadius: 8,
                    fontSize: 14,
                  }}
                >
                  {(selectedMatpel?.kelas_list || []).map((kelas, kelasIndex) => (
                    <option
                      key={kelas?.ysb_kelas_id || kelasIndex}
                      value={kelas?.ysb_kelas_id || ""}
                    >
                      {kelas?.nama_kelas || `Kelas ${kelasIndex + 1}`}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {isFetchingBookScore ? (
              <div
                className="text-center"
                style={{
                  padding: "55px 0",
                }}
              >
                <PulseLoader color="#3f5bea" size={10} />

                <div
                  style={{
                    marginTop: 10,
                    color: "#3f5bea",
                    fontSize: 15,
                  }}
                >
                  Memuat data nilai siswa...
                </div>
              </div>
            ) : (bookScoreData?.data_murid || []).length > 0 ? (
              <div className="book-score-table-wrap">
                <table
                  className="table book-score-table"
                  id="basic-datatable"
                  style={{
                    minWidth: `${
                      55 +
                      315 +
                      Math.max(sumatifTpColumns.length, 1) * 110 +
                      155 +
                      90 +
                      90 +
                      155 +
                      120
                    }px`,
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        rowSpan={2}
                        style={{
                          width: 55,
                          minWidth: 55,
                        }}
                        className="text-center"
                      >
                        No
                      </th>

                      <th
                        rowSpan={2}
                        style={{
                          minWidth: 315,
                        }}
                        className="text-center"
                      >
                        Nama
                      </th>

                      <th
                        colSpan={
                          sumatifTpColumns.length > 0
                            ? sumatifTpColumns.length
                            : 1
                        }
                        style={{
                          minWidth: 130,
                        }}
                        className="text-center"
                      >
                        Sumatif Harian
                      </th>

                      <th
                        rowSpan={2}
                        style={{
                          minWidth: 155,
                        }}
                        className="text-center"
                      >
                        Rata-rata Sumatif Harian
                      </th>

                      <th
                        rowSpan={2}
                        style={{
                          minWidth: 90,
                        }}
                        className="text-center"
                      >
                        ASTS
                      </th>

                      <th
                        rowSpan={2}
                        style={{
                          minWidth: 90,
                        }}
                        className="text-center"
                      >
                        ASAS
                      </th>

                      <th
                        rowSpan={2}
                        style={{
                          minWidth: 155,
                        }}
                        className="text-center"
                      >
                        Rata-rata Sumatif Akhir
                      </th>

                      <th
                        rowSpan={2}
                        style={{
                          minWidth: 120,
                        }}
                        className="text-center"
                      >
                        Nilai Rapor
                      </th>
                    </tr>

                    <tr>
                      {sumatifTpColumns.length > 0 ? (
                        sumatifTpColumns.map((tp, tpIndex) => (
                          <th
                            key={tp?.id || tpIndex}
                            style={{
                              minWidth: 110,
                              whiteSpace: "nowrap",
                            }}
                            className="text-center"
                          >
                            {tp?.name_tp || `TP ${tpIndex + 1}`}
                          </th>
                        ))
                      ) : (
                        <th
                          style={{
                            minWidth: 110,
                          }}
                          className="text-center"
                        >
                          -
                        </th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {sortedBookStudents.map(
                      (student, studentIndex) => (
                        <tr
                          key={
                            student?.ysb_student_id ||
                            studentIndex
                          }
                        >
                          <td
                            style={{
                              width: 55,
                              minWidth: 55,
                              textAlign: "center",
                            }}
                          >
                            <span className="book-score-number">
                              {studentIndex + 1}
                            </span>
                          </td>

                          <td
                            style={{
                              minWidth: 315,
                              fontWeight: 500,
                              color: "#24364b",
                              whiteSpace: "normal",
                            }}
                          >
                            {student?.nama_lengkap || "-"}
                          </td>

                          {sumatifTpColumns.length > 0 ? (
                            sumatifTpColumns.map((tp, tpIndex) => (
                              <td
                                key={`${
                                  student?.ysb_student_id ||
                                  studentIndex
                                }-${tp?.id || tpIndex}`}
                                style={{
                                  minWidth: 110,
                                  textAlign: "center",
                                }}
                              >
                                {formatNilai(
                                  getScoreByTp(student, tp)
                                )}
                              </td>
                            ))
                          ) : (
                            <td
                              style={{
                                minWidth: 110,
                                textAlign: "center",
                              }}
                            >
                              -
                            </td>
                          )}

                          <td
                            style={{
                              minWidth: 155,
                              textAlign: "center",
                            }}
                          >
                            {formatNilai(
                              student?.rata_rata_sumatif_harian
                            )}
                          </td>

                          <td
                            style={{
                              minWidth: 90,
                              textAlign: "center",
                            }}
                          >
                            {formatNilai(student?.asts)}
                          </td>

                          <td
                            style={{
                              minWidth: 90,
                              textAlign: "center",
                            }}
                          >
                            {formatNilai(student?.asas)}
                          </td>

                          <td
                            style={{
                              minWidth: 155,
                              textAlign: "center",
                            }}
                          >
                            {formatNilai(
                              student?.rata_rata_sumatif_akhir
                            )}
                          </td>

                          <td
                            style={{
                              minWidth: 120,
                              textAlign: "center",
                              fontWeight: 700,
                              color: "#087707",
                            }}
                          >
                            {formatNilai(student?.nilai_rapor)}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div
                className="text-center"
                style={{
                  padding: "45px 20px",
                  border: "1px dashed #cbd5e1",
                  borderRadius: 12,
                  color: "#64748b",
                  fontWeight: 600,
                }}
              >
                {bookScoreEmptyMessage}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body">
      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faBook} />
            </span>
            <h4 className="page-title-text">Buku Nilai</h4>
          </div>
        </div>
      </div>

      <div className="body-content">
        <div
          className="d-flex mb-4"
          style={{
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div className="at-search" style={{ flex: 1, minWidth: 240 }}>
            <input
              className="at-input"
              placeholder="Cari buku nilai"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
          </div>

          <select
            className="at-input"
            value={selectedSemesterId}
            onChange={handleChangeSemester}
            style={{
              width: isTabletOrMobile ? "100%" : 260,
              cursor: "pointer",
              background: "#fff",
            }}
          >
            <option value="">Pilih Semester</option>
            {semesterOptions.map((item) => (
              <option key={item?.id} value={item?.id}>
                {getSemesterLabel(item)}
                {Number(item?.status) === 1 ? " - Aktif" : ""}
              </option>
            ))}
          </select>
        </div>

        {isFetching ? (
          <div className="text-center" style={{ padding: "30px 0" }}>
            <PulseLoader color={"#3f5bea"} size={10} />
            <div
              style={{
                marginTop: 10,
                color: "#3f5bea",
                fontWeight: 400,
                fontSize: "16px",
              }}
            >
              Memuat data buku nilai...
            </div>
          </div>
        ) : (
          <>
            {paginatedData.length > 0 ? (
              <div
                className="matpel-card-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: isTabletOrMobile
                    ? "1fr"
                    : "repeat(1, minmax(0, 1fr))",
                  gap: 16,
                  maxWidth: "100%",
                }}
              >
                {paginatedData.map((row) => (
                  <div
                    key={row?.row_key}
                    className="matpel-card-item"
                    onClick={() => handleClickMatpel(row)}
                    title="Klik untuk melihat detail buku nilai"
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 18,
                      padding: 18,
                      cursor: "pointer",
                      boxShadow: "0 10px 26px rgba(67, 104, 197, 0.08)",
                      transition: "0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow =
                        "0 16px 34px rgba(67, 104, 197, 0.14)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 26px rgba(67, 104, 197, 0.08)";
                    }}
                  >
                    <div className="d-flex">
                      <div
                        className="d-flex"
                        style={{ alignItems: "center", gap: 12 }}
                      >
                        <div
                          style={{
                            width: 44,
                            height: 44,
                            borderRadius: 14,
                            background: "rgba(67, 104, 197, 0.12)",
                            color: "#3f5bea",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 18,
                          }}
                        >
                          <FontAwesomeIcon icon={faBookOpen} />
                        </div>

                        <div style={{ minWidth: 0 }}>
                          <div
                            style={{
                              color: "#111827",
                              fontWeight: 700,
                              fontSize: 15,
                              lineHeight: 1.3,
                            }}
                          >
                            {row?.nama_matpel || "-"} -{" "}
                            {row?.nama_tingkatan || "-"}
                          </div>

                          <div
                            style={{
                              marginTop: 5,
                              color: "#6b7280",
                              fontSize: 12,
                              fontWeight: 500,
                            }}
                          >
                            {semesterOptions.find(
                              (item) =>
                                String(item?.id || "") ===
                                String(selectedSemesterId || "")
                            )
                              ? getSemesterLabel(
                                  semesterOptions.find(
                                    (item) =>
                                      String(item?.id || "") ===
                                      String(selectedSemesterId || "")
                                  )
                                )
                              : "-"}
                          </div>
                        </div>
                      </div>

                      <div className="ml-auto">
                        <div
                          className="d-flex"
                          style={{
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              flexWrap: "wrap",
                            }}
                          >
                            {row?.kelas_list?.length > 0 ? (
                              row.kelas_list.map((kelas, kelasIndex) => (
                                <span
                                  key={kelas?.ysb_kelas_id || kelasIndex}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6,
                                    padding: "6px 10px",
                                    borderRadius: 999,
                                    background:"#e8f1ff",
                                    color: "#2563eb",
                                    fontSize: 12,
                                    fontWeight: 700,
                                  }}
                                >
                                  {kelas?.nama_kelas || "-"} 
                                </span>
                              ))
                            ) : (
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 6,
                                  padding: "6px 10px",
                                  borderRadius: 999,
                                  background: "#fee2e2",
                                  color: "#b91c1c",
                                  fontSize: 12,
                                  fontWeight: 700,
                                }}
                              >
                                <FontAwesomeIcon icon={faChalkboardTeacher} />
                                Belum ada kelas
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="text-center"
                style={{
                  padding: "40px 20px",
                  background: "#fff",
                  borderRadius: 16,
                  border: "1px dashed #cbd5e1",
                  color: "#6b7280",
                  fontWeight: 600,
                }}
              >
                Data buku nilai tidak ditemukan
              </div>
            )}

            {filteredData.length > 0 && (
              <div className="at-pagination mt-4">
                <div className="d-flex" style={{ gap: 8, alignItems: "center" }}>
                  <span className="at-page-info">
                    Menampilkan{" "}
                    <b>
                      {Math.min((tablePage - 1) * rowsPerPage + 1, totalRows)}
                    </b>
                    -<b>{Math.min(tablePage * rowsPerPage, totalRows)}</b> dari{" "}
                    <b>{totalRows}</b> data
                  </span>

                  <select
                    className="at-page-size"
                    value={rowsPerPage}
                    onChange={(e) => {
                      const v = Number(e.target.value) || 10;
                      setRowsPerPage(v);
                      setTablePage(1);
                    }}
                  >
                    <option value={10}>10 / halaman</option>
                    <option value={25}>25 / halaman</option>
                    <option value={50}>50 / halaman</option>
                    <option value={100}>100 / halaman</option>
                  </select>
                </div>

                <div className="d-flex" style={{ gap: 8, alignItems: "center" }}>
                  <button
                    className="at-page-btn"
                    onClick={() => goToPage(tablePage - 1)}
                    disabled={tablePage <= 1}
                  >
                    Prev
                  </button>

                  <div className="at-page-numbers">
                    {pageNumbers.map((p, idx) =>
                      p === "..." ? (
                        <span
                          key={`dots-${idx}`}
                          className="at-page-info"
                          style={{ padding: "0 6px" }}
                        >
                          ...
                        </span>
                      ) : (
                        <button
                          key={`page-${p}`}
                          className={`at-page-number ${
                            p === tablePage ? "active" : ""
                          }`}
                          onClick={() => goToPage(p)}
                        >
                          {p}
                        </button>
                      )
                    )}
                  </div>

                  <button
                    className="at-page-btn"
                    onClick={() => goToPage(tablePage + 1)}
                    disabled={tablePage >= totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
